export const ACCORDION_CLASS_NAME = 'mui-accordion';
export const DESKTOP_NAVBAR_CLASS_NAME = 'navbar-desktop-inner';
export const DESKTOP_NAVBAR_WRAPPER_CLASS_NAME = 'navbar-desktop-wrapper';
export const STACK_HERO_CLASS_NAME = 'stack-hero';
export const STACK_CENTER_ROW_DIRECTION = 'stack-center-row-direction';
export const STACK_START_ROW_DIRECTION = 'stack-start-row-direction';
export const STACK_CENTER_COLUMN_DIRECTION = 'stack-center-column-direction';
export const INFORMATION_STACK_WITH_BORDER = 'information-stack-with-border';
export const INFORMATION_STACK_NO_BORDER = 'information-stack-no-border';
export const STACK_CENTER = 'stack-center';
export const BOX_CENTER_IMAGE = 'box-center-image';
export const ENTITIES_LIST_CLASS_NAME = 'entities-list';
export const STACK_START_COLUMN_DIRECTION = 'stack-start-column-direction';
export const STACK_SPACE_BETWEEN_ROW_DIRECTION = 'stack-space-between-row-direction';
export const STACK_PRODUCT_SECTION_COMPONENT = 'stack-product-section-component';
